var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.236574 24.6552C0.148443 24.8472 0.136224 25.0562 0.201567 25.254C0.26691 25.4517 0.406673 25.6287 0.602015 25.7611C0.797357 25.8935 1.03889 25.975 1.29405 25.9945C1.54921 26.014 1.80574 25.9706 2.02905 25.8702L28.3521 13.859C28.548 13.7725 28.7113 13.6457 28.825 13.4918C28.9387 13.338 28.9987 13.1626 28.9987 12.984C28.9987 12.8053 28.9387 12.63 28.825 12.4761C28.7113 12.3222 28.548 12.1954 28.3521 12.109L2.02905 0.127718C1.80641 0.0283801 1.55108 -0.0144025 1.29716 0.005084C1.04324 0.0245705 0.802818 0.105399 0.608 0.236774C0.413182 0.368149 0.273244 0.543816 0.206876 0.740315C0.140508 0.936815 0.150869 1.14479 0.236574 1.33647L5.17371 12.9952L0.236574 24.6552Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2036 12.9966H5.17578",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.0261d11cf7c3db325859c9d603ae263d.svg";
export { ForwardRef as ReactComponent };